import React from "react";
import {
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import { useSelector } from "react-redux";
import helpIcon from "../../../../../../../../assets/images/helpIcon.svg";

const StyledTableCellHead = styled(TableCell)(({ theme }) => ({
  fontFamily: "Poppins",
  fontWeight: "400",
  lineHeight: "18px",
  fontSize: "14px",
  color: "#FFFFFF",
  textTransform: "capitalize",
  padding: "16px",
}));

const StyledTableCellBody = styled(TableCell)(({ theme }) => ({
  fontFamily: "Poppins",
  fontWeight: "400",
  fontSize: "13px",
  color: "#516778",
  padding: theme.spacing(1),
  paddingTop: "15px",
  paddingBottom: "10px",
}));

function CreditTable(props: any) {
  const {
    creditEdit,
    onBranchClick,
    handleCreditChange,
    hasAllBranchAccess,
    onEditClick,
    metaCreditDitribution,
    creditEditedData,
  } = props;
  const { userById } = useSelector((state: any) => state.userDetails);

  function getLastDateHeader() {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();

    const lastDate = new Date(year, month + 1, 0);
    const day = lastDate.getDate();

    const monthName = lastDate.toLocaleString("default", { month: "long" });

    function getOrdinalSuffix(day: any) {
      if (day > 3 && day < 21) return day + "th";
      switch (day % 10) {
        case 1:
          return day + "st";
        case 2:
          return day + "nd";
        case 3:
          return day + "rd";
        default:
          return day + "th";
      }
    }

    return `${getOrdinalSuffix(day)}  ${monthName} ${year}`;
  }

  return (
    <>
      <div
        style={{
          borderRadius: "6PX",
          border: "1px solid #EAECF0",
          overflow: "hidden",
        }}
      >
        <TableContainer
          sx={{
            borderRadius: "6px",
            maxHeight: creditEdit
              ? "calc(100vh - 400px)"
              : "calc(100vh - 330px)",
            minHeight: creditEdit
              ? "calc(100vh - 400px)"
              : "calc(100vh - 330px)",
            overflowY: "auto",
            background: "#fff",
          }}
        >
          <Table
            sx={{
              minWidth: 700,
            }}
          >
            <TableHead
              sx={{
                position: "sticky",
                top: 0,
                zIndex: 999,
                background: "#073E53",
              }}
            >
              <TableRow>
                <StyledTableCellHead sx={{ minWidth: 220 }}>
                  Branches
                </StyledTableCellHead>
                <StyledTableCellHead sx={{ minWidth: 220, maxWidth: 250 }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                      gap: "6px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <span>Monthly Credits</span>
                      <Tooltip
                        arrow
                        title={
                          <>{`(Total - 300) Valid till - ${getLastDateHeader()}`}</>
                        }
                        PopperProps={{
                          style: { zIndex: 999999 },
                        }}
                        componentsProps={{
                          tooltip: {
                            sx: {
                              bgcolor: "#101828",
                              color: "#fff",
                              fontSize: "12px",
                              fontWeight: "500",
                              padding: "8px 12px",
                              "& .MuiTooltip-arrow": {
                                color: "#101828",
                              },
                            },
                          },
                        }}
                      >
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginLeft: "3PX",
                          }}
                        >
                          <img src={helpIcon} alt="helpIcon" />
                        </span>
                      </Tooltip>
                    </div>

                    {creditEdit && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          width: "100%",
                          padding: "0 12px",
                        }}
                      >
                        <div style={{ width: "50%", textAlign: "center" }}>
                          Old
                          {/* Credit Distribution */}
                        </div>
                        <div style={{ width: "50%", textAlign: "center" }}>
                          New
                          {/* Credit Distribution */}
                        </div>
                      </div>
                    )}
                  </div>
                </StyledTableCellHead>

                <StyledTableCellHead sx={{ minWidth: 150, maxWidth: 150 }}>
                  Monthly Credit Usage
                </StyledTableCellHead>
                <StyledTableCellHead sx={{ minWidth: 120, maxWidth: 120 }}>
                  Addon Credits
                </StyledTableCellHead>
                <StyledTableCellHead sx={{ minWidth: 150 }} align="center">
                  Credits Used
                </StyledTableCellHead>

                <StyledTableCellHead sx={{ minWidth: 150 }} align="center">
                  Credits Remaining
                </StyledTableCellHead>
              </TableRow>
            </TableHead>
            <TableBody sx={{ background: "#fff" }}>
              {(hasAllBranchAccess
                ? metaCreditDitribution
                : metaCreditDitribution?.filter(
                    (item: any) => item?.branchId === userById?.branchId
                  )
              )?.map((item: any, index: any) => (
                <TableRow key={index}>
                  <StyledTableCellBody
                    sx={{
                      textTransform: "capitalize",
                      color: "#142c44",
                      fontWeight: "500",
                    }}
                    onClick={
                      !creditEdit ? () => onBranchClick(item) : undefined
                    }
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                      }}
                    >
                      <div
                        style={{
                          cursor: !creditEdit ? "pointer" : "default",
                        }}
                      >
                        {item?.branchName}
                      </div>

                      <div>
                        {item?.nextMonthlyCredit >= 0 &&
                          item?.newBranch == false &&
                          creditEdit &&
                          "(Next Monthly Credit -" +
                            item?.nextMonthlyCredit +
                            ")"}
                      </div>
                      {item?.newBranch && (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <span
                            style={{ color: "#0a0a23", fontWeight: "bold" }}
                          >
                            *
                          </span>
                          <span style={{ color: "#00c2a8", marginLeft: "4px" }}>
                            New
                          </span>
                        </div>
                      )}
                    </div>
                  </StyledTableCellBody>
                  <StyledTableCellBody
                    align="center"
                    sx={{
                      background: creditEdit ? "#FBF8F8" : "#fff",
                      minWidth: 220,
                      maxWidth: 250,
                    }}
                  >
                    {creditEdit ? (
                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          justifyContent: "center",
                        }}
                      >
                        <div style={{ width: "48%", textAlign: "center" }}>
                          {item?.monthlyCredit}
                        </div>
                        <div
                          style={{
                            width: "2%",

                            borderLeft: "2px solid #808080",
                          }}
                        ></div>
                        <div style={{ width: "48%", textAlign: "center" }}>
                          <input
                            type="number"
                            name="credit"
                            min="0"
                            max="1000"
                            step="1"
                            style={
                              {
                                WebkitAppearance: "auto",
                                MozAppearance: "textfield", // For Firefox
                                appearance: "auto",
                                width: "80px",
                              } as any
                            }
                            value={
                              creditEditedData?.find(
                                (data: any) => data.branchId === item.branchId
                              )?.credit || 0
                            }
                            onChange={(e) =>
                              handleCreditChange(item?.branchId, e)
                            }
                            onInput={(e) => {
                              const target = e.target as HTMLInputElement;
                              target.value = target.value.replace(
                                /[^0-9]/g,
                                ""
                              );
                            }}
                          ></input>
                        </div>
                      </div>
                    ) : (
                      <>
                        {item.newBranch == false ? (
                          item?.monthlyCredit
                        ) : (
                          <div>
                            0
                            <div
                              style={{ paddingLeft: "5px", fontSize: "10px" }}
                            >
                              Please edit the credits by {getLastDateHeader()}{" "}
                              or the credit Distribution will be reset to
                              default
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </StyledTableCellBody>
                  <StyledTableCellBody align="center">
                    {item?.monthlyCreditUsed}
                  </StyledTableCellBody>
                  <StyledTableCellBody align="center">
                    {item?.addOnCredit}
                  </StyledTableCellBody>

                  <StyledTableCellBody align="center">
                    {Number(item?.monthlyCreditUsed + item?.addOnCreditUsed) +
                      "/" +
                      Number(item?.monthlyCredit + item?.addOnCredit)}
                  </StyledTableCellBody>
                  <StyledTableCellBody
                    sx={{ color: "#14181F", fontWeight: "700" }}
                    align="center"
                  >
                    {Number(
                      item?.addOnRemainingCredit + item?.monthlyRemainingCredit
                    )}
                  </StyledTableCellBody>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  );
}

export default CreditTable;
